module.exports = __webpack_public_path__ + "img/scene8.cc3bbbd1.gif";